import { Factory } from '../Factory';
import { TagForm } from '../../model/tagging/TagForm';

export class TagFormService {
  private TagFormResource;
  private TagFormResourceByRole;
  private ResourceWrapperService: any;
  private configService: any;
  private ElementTagFormResource;

  constructor($resource: any, configService: any, resourceWrapperService: any) {
    this.ResourceWrapperService = resourceWrapperService;
    this.configService = configService;

    let rawTagFormService = $resource(`${this.configService.getServerBaseUrlForResource()}/project/:projectId/tagform/:id`,
      {id: "@id", projectId: "@projectId"},
      {
        update: {method: "PUT"}
      }
    );

    let rawTagFormByRoleService = $resource(`${this.configService.getServerBaseUrlForResource()}/project/:projectId/tagform/role/:roleId`,
      {projectId: "@projectId", roleId: "@roleId"},
      {
        update: {method: "PUT"}
      }
    );

    let rawElementTagFormService = $resource(`${this.configService.getServerBaseUrlForResource()}/project/:projectId/category/:categoryId/tagform`,
      {projectId: "@projectId", categoryId: "@categoryId"},
      {
        update: {method: "PUT"},
        query: {method: "GET", params: {page: 1, limit: 20}, isArray: false}
      }
    );

    this.TagFormResource = this.ResourceWrapperService.WrapActions(rawTagFormService);
    this.TagFormResourceByRole = this.ResourceWrapperService.WrapActions(rawTagFormByRoleService);
    this.ElementTagFormResource = this.ResourceWrapperService.WrapActions(rawElementTagFormService);
  }

  public save(tagForm: TagForm, callback: Function, errorCallback: Function) {
    return tagForm.id ? this.update(tagForm, callback, errorCallback) : this.add(tagForm, callback, errorCallback);
  }

  public add(tagForm: TagForm, callback: Function, errorCallback: Function) {
    let formService = this.getFormAsService(tagForm);

    return formService.$save(tagForm, (tagForm) => callback && callback(tagForm), (data) => errorCallback && errorCallback(data));
  }

  public update(tagForm: TagForm, callback: Function, errorCallback: Function) {
    let formService = this.getFormAsService(tagForm);

    return formService.$update((tagForm) => callback && callback(tagForm), (data) => errorCallback && errorCallback(data));
  }

  /**
   * For Full-View to call (will auto-select form based on role)
   * @param projectId
   * @param callback
   * @returns {any}
   */
  public findByProject(projectId: string, callback: Function) {
    return this.TagFormResource.get({projectId: projectId}, (tagForm) => callback && callback(tagForm));
  }

  /**
   * For Admin only.
   *
   * @param projectId
   * @param roleId
   * @param callback
   * @returns {any}
   */
  public findByProjectAndRole(projectId: string, roleId: string, callback: Function) {
    return this.TagFormResourceByRole.get({
      projectId: projectId,
      roleId: roleId
    }, (tagForm) => callback && callback(tagForm));
  }

  public createTagForm = (projectId, roleId) => new TagForm(projectId, roleId);

  public getFormAsService(tagForm: TagForm) {
    return new this.TagFormResource(angular.copy(tagForm));
  }

  public getTags(projectId: string, categoryId: number, ids: string[], page: number, limit: number, callback: Function) {
    return this.ElementTagFormResource.query({
      projectId: projectId,
      existingIds: ids, //JSON.stringify(ids),
      categoryId: categoryId,
      page: page,
      limit: limit
    }, (tags) => (callback) && callback(tags));
  }

  public getTagFormElement(projectId: string, tagId: string, callback: Function) {
    return this.ElementTagFormResource.get({
      projectId: projectId,
      tagId: tagId
    }, (tags) => (callback) && callback(tags));
  }
}

frontendApp.factory("TagFormService", ['$resource', 'ConfigService', 'ResourceWrapperService', function(resource, configService, resourceWrapperService) {
  return new TagFormService(resource, configService, resourceWrapperService);
}]);
